import React from "react";
import { FieldArray } from "formik";
import { Row, Col, Button } from "reactstrap";
import { Plus } from "react-feather";
import { customReactSelectStyles } from "../../../styles/ReactSelectStyles";
import { SlabSectionProps } from "../../../types/tax-types/TaxTypes";
import SlabCard from "./SlabCard";
import { useTranslation } from "react-i18next";

const SlabSection: React.FC<SlabSectionProps> = ({
  values,
  errors,
  setFieldTouched,
  generateId,
}) => {
  const { t } = useTranslation();

  return (
    <Row className="g-3">
      <Col md={12}>
        <FieldArray name="slab_rule">
          {({ push, remove, replace }) => (
            <div className="mb-4">
              {values.slab_rule && values.slab_rule.length > 0 && (
                <div>
                  {values.slab_rule.map((slab: any, slabIdx: number) => {
                    const slabErrors =
                      (errors.slab_rule as any)?.[slabIdx] || {};
                    const slabRanges = slab.slab_range || [
                      {
                        id: generateId(),
                        range_order: "1",
                        range_income_from: "",
                        range_income_to: "",
                        range_calculation_mode: "fixed",
                        range_fixed_amount: null,
                        range_percentage: null,
                        isEditing: true,
                      },
                    ];

                    const slabCardProps = {
                      slab,
                      slabIdx,
                      slabErrors,
                      slabRanges,
                      replace,
                      remove,
                      push,
                      setFieldTouched,
                      generateId,
                      customReactSelectStyles,
                    };

                    return <SlabCard key={slab.id} {...slabCardProps} />;
                  })}
                </div>
              )}
              {!(values.slab_rule || []).some(
                (slab: any) => slab.isEditing
              ) && (
                <div className="d-flex justify-content-end">
                  <Button
                    color="info"
                    onClick={() => {
                      push({
                        id: generateId(),
                        slab_name: "",
                        slab_description: "",
                        slab_range: [
                          {
                            id: generateId(),
                            range_order: "1",
                            range_income_from: "",
                            range_income_to: "",
                            range_calculation_mode: "fixed",
                            range_fixed_amount: null,
                            range_percentage: null,
                            isEditing: true,
                          },
                        ],
                        isEditing: true,
                      });
                    }}
                  >
                    <Plus size={16} className="me-2" />
                     {t("AddSlab")}
                  </Button>
                </div>
              )}
            </div>
          )}
        </FieldArray>
      </Col>
    </Row>
  );
};

export default SlabSection;
